import { render, staticRenderFns } from "./MessagesStatistics.vue?vue&type=template&id=6047aedc&"
import script from "./MessagesStatistics.vue?vue&type=script&lang=ts&"
export * from "./MessagesStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports